define.alias("shared/helpers/concat-classes", "calendar/helpers/concat-classes");